import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, changeLanguage } = useLanguage();
  const isEnglish = language === 'en';

  const toggle = () => changeLanguage(isEnglish ? 'fr' : 'en');

  return (
    <div className={`language-switcher flex items-center gap-2 ${className}`}>
      <span className={`text-xs font-semibold transition-colors ${!isEnglish ? 'text-foreground' : 'text-muted-foreground'}`}>FR</span>
      <button
        type="button"
        role="switch"
        aria-checked={isEnglish}
        onClick={toggle}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${
          isEnglish ? 'bg-primary' : 'bg-muted-foreground/40'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${
            isEnglish ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className={`text-xs font-semibold transition-colors ${isEnglish ? 'text-foreground' : 'text-muted-foreground'}`}>EN</span>
    </div>
  );
};

export default LanguageSwitcher;